export default __webpack_public_path__ + "static/media/06.a48ea99f.jpg";